import { render, staticRenderFns } from "./RegulationExcel.vue?vue&type=template&id=524514c0&scoped=true"
import script from "./RegulationExcel.vue?vue&type=script&lang=js"
export * from "./RegulationExcel.vue?vue&type=script&lang=js"
import style0 from "./RegulationExcel.vue?vue&type=style&index=0&id=524514c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524514c0",
  null
  
)

export default component.exports